import React from 'react';

const NationalLotteries = ({ ...r }) => {
	return (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" { ...r }>
		<path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#F2F2F2"/>
		<circle cx="20" cy="18.5" r="9.25" stroke="#0250C9" stroke-width="1.5"/>
		<circle cx="17" cy="13.5" r="1.5" stroke="#0250C9"/>
		<circle cx="23" cy="16.5" r="1.5" stroke="#0250C9"/>
		<circle cx="26" cy="20.5" r="1.5" stroke="#0250C9"/>
		<circle cx="23.1426" cy="23.5" r="1.5" stroke="#0250C9"/>
		<circle cx="18" cy="24.5" r="1.5" stroke="#0250C9"/>
		<circle cx="20" cy="20.5" r="1.5" stroke="#0250C9"/>
		<circle cx="15" cy="20.5" r="1.5" stroke="#0250C9"/>
		<line x1="10.75" y1="30.75" x2="29.25" y2="30.75" stroke="#0250C9" stroke-width="1.5" stroke-linecap="round"/>
		<line x1="24.9533" y1="26.965" x2="26.0928" y2="30.2743" stroke="#0250C9" stroke-width="1.5" stroke-linecap="round"/>
		<line x1="15.3992" y1="27.4563" x2="14.1449" y2="30.7238" stroke="#0250C9" stroke-width="1.5" stroke-linecap="round"/>
	</svg>
	);
};

export default NationalLotteries;
